import { useMutation, gql } from '@apollo/client';

import {
  ConfirmarAlocacaoMutation,
  ConfirmarAlocacaoMutationVariables,
} from './__generated__/ConfirmarAlocacaoMutation';

const CONFIRMAR_ALOCACAO_MUTATION = gql`
  mutation ConfirmarAlocacaoMutation($id_alocacao: Int!) {
    confirmarAlocacao(input: { id_alocacao: $id_alocacao }) {
      id_alocacao
      id_oferta
      id_turma
      dat_alocacao
      ind_status
      planejamento
      disciplina {
        id_disciplina
        dsc_sigla
        num_carga_horaria
      }
      professor {
        id_professor
        dsc_nome_professor
      }
    }
  }
`;

const useConfirmarAlocacaoMutation = () => {
  return useMutation<ConfirmarAlocacaoMutation, ConfirmarAlocacaoMutationVariables>(
    CONFIRMAR_ALOCACAO_MUTATION
  );
};

export { useConfirmarAlocacaoMutation };
